import React from 'react';import PageHeader from '../components/PageHeader';
import DynamicApplicationList from './DynamicApplicationList';
import styles from './ApplicantDashboard.module.css';

const ApplicantDashboard: React.FC = () => {
  return (
    <div className={styles.container}>
      <PageHeader
        title="Panel del Investigador"
        subtitle="Gestione sus postulaciones a fondos de investigación UC"      />

      <div className={styles.content}>
        <DynamicApplicationList />
      </div>
    </div>
  );
};

export default ApplicantDashboard;
